require("navigation");

/*==================================
=            PREHOME               =
===================================*/

$(window).ready(function () {
  var name_of_prehomepage_cookie = "prehome_page"
  var name_of_prehomepage_cookie_oneday = "prehome_page_oneday"
  //if(window.mobileAndTabletcheck()){
    // si mobile et si pas cookie de la prehome page

  function haveCookie (_name) {
    if (document.cookie.indexOf(_name) >= 0) {
      return false;
    }
    return true;
  }

  function addCookie (_name, _hunger, _size) {
    if (_size) {
      var date = new Date();
      date.setTime(date.getTime() + (_size * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    }else{
      var expires = "";
    }
    document.cookie = _name + "=" + _hunger + expires + "; path=/";
  }



                                                                // ATTENTION && FALSE
  //if(haveCookie(name_of_prehomepage_cookie) && window.mobileAndTabletcheck() && haveCookie(name_of_prehomepage_cookie_oneday)){
  if (false) {
    var url_img, url_dll;
    if(window.location.host.search('prestige') > -1){
      url_img = '/web/public/img/logo-megagence-maison-prestige.png';
    }else{
      url_img = '/web/public/img/logo-megagence-maison.png';
    }

    /* TODO handle megagence app
    if(navigator.userAgent.match(/Android/i)){
      url_dll = "https://play.google.com/store/apps/details?id=fr.appsolute.megagence";
    }else if(navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)){
      url_dll = "https://itunes.apple.com/us/app/megagence/id1063261294?l=fr&ls=1&mt=8";
    }else{
      url_dll = "https://itunes.apple.com/us/app/megagence/id1063261294?l=fr&ls=1&mt=8";
    }
    */

    $('body').prepend('<div class="mobile-hb"><div class="mobile-hb-wrapper"><div class="mobile-hb-full"><img class="mobile-hb--img" src="/web/public/img/logo_megagence_prehome.png" alt="Logo MegAgence Maison"><div class="mobile-hb-bloc"><p class="mobile-hb--txt">Votre logement au bout des doigts avec l\'application !</p></div></div><div class="mobile-hb-row"><div class="mobile-hb-half"><img class="mobile-hb--img" src="/web/public/img/mockup.png" alt="Logo MegAgence Maison"></div><div class="mobile-hb-half"><div class="mobile-hb-wrapper-btn-app"><a class="mobile-hb-btn--app" href="'+url_dll+'" title="Utilisez l\'application">Utilisez l\'application</a></div><div class="mobile-hb-wrapper-btn-close"><a class="mobile-hb-btn--close" href="" title="Continuez sur le site">Continuez sur le site<span class="mobile-hb--arrow">></span></a></div><div class="mobile-hb-wrapper-btn-checkbox"><input type="checkbox" id="cbox" value="choix"><label for="cbox">Se souvenir de mon choix</label></div></div></div></div></div>');

    var H = $('.mobile-hb').height() - $('.mobile-hb-row').height() - 35;

    var centre_vertical = Math.abs((H-$('.mobile-hb-row').height())/2);

    $('.mobile-hb-row').css({"padding": centre_vertical+"px 0"})

    $('.mobile-hb-btn--close').click(function (e) {
      e.preventDefault();
      addCookie(name_of_prehomepage_cookie_oneday, true, 1)
      if ($('#cbox').is(':checked')) {
        addCookie(name_of_prehomepage_cookie, true, 390)
      }
      $('.mobile-hb').remove();
      margTopHeader();
    })
    function margTopHeader () {
      if($('.mobile-hb').length && window.innerWidth <= 768){
        $('header').css('top', $('.mobile-hb').height()+'px')
      }else{
        $('header').css('top', '')
      }
    }
    if($('.mobile-hb').length && window.innerWidth <= 768){
      $('.mobile-hb--img').load(function () {
        $('header').css('top', $('.mobile-hb').height()+'px')
      })
    }else{
      $('header').css('top', '')
    }
    window.onresize = function(event) {
      margTopHeader();
    }
  }
})


/*==================================
=          Flexslider              =
===================================*/

/*$('.home-flexslider').flexslider({
  directionNav: true,
  animation: "slide",
  itemWidth: getItemSize(),
  minItems: getGridSize(),
  maxItems: getGridSize(),
  animationLoop: false,
  controlNav: false,
});
function getGridSize() {
  return (window.innerWidth < 991) ? 2 : 3;
}
function getItemSize() {
  return (window.innerWidth < 991) ? 700 : 385;
}

$( window ).resize(function() {
  var gridSize = getGridSize();
  var itemSize = getItemSize();
  if($('.home-flexslider')){
    $('.home-flexslider').data('flexslider').setOpts({minItems: gridSize, maxItems: gridSize, itemWidth: itemSize}); //, itemWidth: 700  
  }
});*/


/*==================================
=          Same height             =
===================================*/

function hauteurEgale(group) {
  tallest = 0;
  group.css('height', '');
  group.each(function() {
    thisHeight = $(this).height();
    if(thisHeight > tallest) {
      tallest = thisHeight;   
    }
  });
  group.css('height',tallest+'px');
}

$(window).load(function() {
  if (window.innerWidth > 768) {
    hauteurEgale($(".project-sh"));
  };
  if (window.innerWidth > 768) {
    hauteurEgale($(".temoignages-sh"));
  };
  if (window.innerWidth > 768) {
    hauteurEgale($(".news-sh"));
  };
  
})

$(window).load(function() {
  if(window.innerWidth < 992) {
    $(".sblk.search-home.mag").appendTo(".main-sblk");
  }
})